import { create } from "zustand";
import { combine } from "zustand/middleware";

type NavLink = {
  url: string;
  title: string;
  classList: string;
};

type SocialAria = {
  label: string;
};

type SocialLink = {
  url: string;
  target: string;
  aria?: SocialAria;
  icon: string;
};

type NavLayout = {
  container: NavLink[];
  mega_menu: Array<NavLink[]>;
};

type FooterLayout = {
  columns: Array<NavLink[]>;
  social: SocialLink[];
};

export type Layout = {
  nav?: NavLayout;
  footer?: FooterLayout;
};

const useLayoutStore = create(
  combine({ layout: {} }, (set) => ({
    setLayout: (layout: Layout) => set(() => ({ layout: layout })),
  })),
);

export default useLayoutStore;
